<ng-container *ngrxLet="{selectLoadingTarificationPhaseB:selectLoadingTarificationPhaseB$,
                         selectDatasTarificationPhaseB:selectDatasTarificationPhaseB$} as datas">
  @if (datas.selectLoadingTarificationPhaseB | spinnerIsStarted) {
    <div style="display: flex;justify-content: center;height: 177px;align-items:center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <div style="width: 900px">
      <app-oav-text-preco [selectDatasTarificationPhaseB$]="selectDatasTarificationPhaseB$"></app-oav-text-preco>
      <div style="flex-direction: row;display: flex">
        <app-preco-left-column [ar]="listLeftColumn" [listLeftColumn$]="listLeftColumn$"
                               (onCheck)="checkProducts($event)"
                               [changePrice$]="selectPricesTarificationPhaseB$">
        </app-preco-left-column>
        <app-preco-default [changePrice$]="selectPricesTarificationPhaseB$"
                           [changeBorder$]="changeBorder$"
                           (onCheck)="checkFormule($event, datas.selectDatasTarificationPhaseB)"
                           [ar]="listFormuleMinimales"
                           [formuleSelected]="formuleEnum.MINIMALE"></app-preco-default>
        <app-preco-default [changePrice$]="selectPricesTarificationPhaseB$"
                           [changeBorder$]="changeBorder$"
                           [ar]="listFormuleConseillee"
                           (onCheck)="checkFormule($event, datas.selectDatasTarificationPhaseB)"
                           [formuleSelected]="formuleEnum.CONSEILLEE"></app-preco-default>
        <app-preco-sur-mesure [changePrice$]="selectPricesTarificationPhaseB$"
                              [formuleSelected]="formuleEnum.SUR_MESURE"
                              [listFormuleSurMesure$]="listFormuleSurMesure$"
                              [ar]="listFormuleSurMesure"
                              [changeBorder$]="changeBorder$"
                              [checkProject$]="checkProject$"
                              [onError$]="onError$"
                              [caisse]="caisse"
                              (onError)="checkError($event)"
                              (onCheck)="checkFormule($event, datas.selectDatasTarificationPhaseB)">
        </app-preco-sur-mesure>
      </div>

      <div style="display: flex;flex-direction: row;height: 130px;">
        <div style="width: 295px;"></div>
        <div style="width:590px;border: 10px solid #EEEEEE;    z-index: 100;">
          <div class="footer" *ngrxLet="{prices: selectPricesTarificationPhaseB$} as datas">
            @if(datas.prices | CheckShowMontantTarificationPhaseBPipe : currentFormuleSelected : 'CTT02' : errorOnFormgroup) {
              <div> Dont {{ datas.prices | ShowMontantTarificationPhaseBPipe : currentFormuleSelected: 'CTT02' }}  sur le produit
                <span
                  [ngStyle]="formuleProductEnum.FORMULE_GROUPAMA_SECURITE | ColorPipe: false">Groupama Sécurité (3)</span>
              </div>
            }
            @if (datas.prices | CheckShowMontantTarificationPhaseBPipe : currentFormuleSelected : 'RED02' : errorOnFormgroup) {
              <div> Dont {{ datas.prices | ShowMontantTarificationPhaseBPipe : currentFormuleSelected: 'RED02' }} sur le produit
                <span
                  [ngStyle]="formuleProductEnum.FORMULE_GROUPAMA_SECURITE_RENTE_EDUCATION | ColorPipe: false">Groupama Sécurité Rente éducation (4)</span>
              </div>
            }
            @if (datas.prices | CheckShowMontantTarificationPhaseBPipe : currentFormuleSelected : 'GAV' : errorOnFormgroup) {
              <div> Dont {{ datas.prices | ShowMontantTarificationPhaseBPipe : currentFormuleSelected: 'GAV' }}  sur le produit
                <span [ngStyle]="formuleProductEnum.FORMULE_GROUPAMA_GAV | ColorPipe: false">Groupama Garantie des Accidents de la Vie</span>
              </div>
            }
            @if (datas.prices | CheckShowMontantTarificationPhaseBPipe : currentFormuleSelected : 'OBSEQUES' : errorOnFormgroup) {
              <div> Dont {{ datas.prices | ShowMontantTarificationPhaseBPipe : currentFormuleSelected: 'OBSEQUES' }} sur le produit
                <span [ngStyle]="formuleProductEnum.FORMULE_GROUPAMA_SERENITE_OBSEQUES | ColorPipe: false">Groupama Sérénité Obsèques (4)</span>
              </div>
            }
            @if (errorOnFormgroup?.hasError) {
              <div style="color: red">
                {{ errorOnFormgroup.message }}
              </div>
            }

            @if (datas.prices | CheckTarifPhaseBPipe : currentFormuleSelected : errorOnFormgroup) {
              <div style="color: red">
                @if (currentFormuleSelected === FormuleEnum.SUR_MESURE) {
                  <div>Veuillez remplir les champs de la colonne couverture sur-mesure</div>
                }
                @if (currentFormuleSelected !== FormuleEnum.SUR_MESURE) {
                  <div>Veuillez selectionner une formule...</div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div style="width: 100%;font-style: italic;font-size: 0.6rem;line-height: 20px">
        (1) Ce bilan a été établi à titre indicatif, sur la base des éléments que vous avez déclarés. Cette étude
        ainsi
        que
        les pré-estimations tarifaires annoncées ne constituent en aucun cas un engagement contractuel de Groupama.
        <br>
        <br>
        (2) Exemple pour un prêt de 180 000 € sur 20 ans pour un couple de cadres de 37 ans, non-fumeurs, avec un
        taux
        annuel effectif d'assurance initial de 0,66 % ramené à 0,24 % par emprunteur assuré à 100 % chacun en Décès,
        Perte
        totale et irréversible d’autonomie, Incapacité temporaire totale, Invalidité permanente totale et Option
        Sécurité
        (soit une économie exacte de 14 810 €). Sous réserve de décision médicale de l’assureur et conditions
        contractuelles.
        <br>
        <br>
        (3) Calcul du tarif hors professions et/ou sports à risques et hors avantages commerciaux éventuels.
        <br>
        <br>
        (4) Non inclus, 15€ de frais d’adhésion dû au moment de la première souscription.
      </div>
    </div>
  }
</ng-container>
